import { UserRole } from "../../__generated__/globalTypes";

interface ITaskOwnership {
  createdBy?: { id: number } | null;
  assignedTo?: { id: number } | null;
}

/**
 * Qui peut supprimer une tâche.
 *
 * Le serveur n'impose aucune restriction (§28) : c'est une règle purement front,
 * pour éviter qu'un employé supprime les tâches d'un collègue. Un admin supprime
 * tout ; les autres seulement les tâches qu'ils ont créées ou qui leur sont
 * assignées.
 */
export const canRemoveTask = (
  task: ITaskOwnership,
  me?: { id: number; role: UserRole } | null
): boolean => {
  if (!me) return false;
  if (me.role === UserRole.Admin) return true;
  return task.createdBy?.id === me.id || task.assignedTo?.id === me.id;
};
